export { default } from './Boleto25MudancaRazaoSocial';
